import { render, staticRenderFns } from "./TaiwanStartups.vue?vue&type=template&id=7a2fa441&"
import script from "./TaiwanStartups.vue?vue&type=script&lang=js&"
export * from "./TaiwanStartups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports